const commonFil = {
    common: require('../../lang/fil/common/Common').default,
};

export default commonFil;